var map = {
	"./1.png": 6634,
	"./2.png": 7217,
	"./3.png": 9736,
	"./4.png": 8727,
	"./anonymous.png": 8348,
	"./avatar.png": 5536,
	"./dislike.png": 6822,
	"./ellipse.png": 7801,
	"./image.png": 4,
	"./like.png": 4898,
	"./logo.png": 2806,
	"./more.png": 1920,
	"./past.png": 2175,
	"./plus1.png": 6058,
	"./rectangle.png": 4452
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4504;